export const guidanceByService = {
'/accreditation-support/chas':['chas-documents'],
'/accreditation-support/constructionline':['constructionline-delays'],
'/accreditation-support/achilles-ssip':['achilles-evidence'],
'/iso-management-systems':['iso-9001-2026-changes','iso-9001-cost','iso-gap-analysis','iso-certification-audit'],
'/iso-management-systems/iso-9001':['iso-9001-2026-changes','iso-9001-cost','iso-gap-analysis','iso-certification-audit'],
'/iso-management-systems/iso-14001':['iso-gap-analysis','iso-certification-audit','iso-nonconformity-response'],
'/iso-management-systems/iso-45001':['iso-gap-analysis','iso-certification-audit','iso-nonconformity-response'],
'/compliance-audits':['iso-gap-analysis','iso-nonconformity-response'],
'/competent-person-support':['what-is-a-competent-person','competent-person-small-business'],
'/safety-support':['what-is-a-competent-person','competent-person-small-business'],
'/compliance-documentation':['policy-procedure-work-instruction','health-safety-documents-manufacturer'],
'/health-and-safety':['what-is-a-competent-person','health-safety-documents-manufacturer']
};
export const serviceByInsight = {
'chas-documents':'/accreditation-support/chas',
'constructionline-delays':'/accreditation-support/constructionline',
'achilles-evidence':'/accreditation-support/achilles-ssip',
'iso-9001-2026-changes':'/iso-management-systems/iso-9001',
'iso-9001-cost':'/iso-management-systems/iso-9001',
'iso-gap-analysis':'/iso-management-systems',
'iso-certification-audit':'/iso-management-systems',
'iso-nonconformity-response':'/compliance-audits',
'what-is-a-competent-person':'/competent-person-support',
'competent-person-small-business':'/competent-person-support',
'policy-procedure-work-instruction':'/compliance-documentation',
'health-safety-documents-manufacturer':'/compliance-documentation'
};